import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'react-bootstrap';


const Stage2 = () => {


    return (
        <>
            {/* <div className="">
            <h1 className='text-blue text-uppercase display-3'><b>Stage&nbsp;2</b></h1>
            <div className='text-center cardBox mt-5'>
                <div>1 USDT = 4166.67 INFI Infinity</div>

                <h1 className='text-gradient'><b>$3.5 per token</b></h1>
                <div className='d-flex gap-2 mt-4 mb-4 justify-content-center'>
                    <Button variant='outline-blue'>400k tokens for sale!</Button>
                    <Button variant='outline-blue'>800k tokens sold!</Button>
                </div>
                <Button variant='primary' className='text-black w-100'><b>CONNECT WALLET</b></Button>
            </div>
        </div> */}
            {/* --------------------------------- */}
            <div className="">
                <h1 className='text-blue text-uppercase display-3'><b>Stage&nbsp;2</b></h1>
                <div className='text-center cardBox mt-5'>
                <h1 className='text-gradient'><b>COMING SOON . . . </b></h1>   
                    <div>1 INFI =  3.5 USDT</div>

                    
                    {/* <small className='mb-0 text-white text-break'>0x117F26717BF9344fdeA0AE55Cc87C0AB94E8E0dD</small> */}
                    <div className=' mt-4 mb-4'>
                        {/* <Button variant='primary' className='text-black w-100 mb-3 text-uppercase fs-6'><b>buy infi</b></Button>
                        <Button variant='primary' className='text-black w-100 text-uppercase fs-6'><b>disconnect</b></Button> */}
                    </div>

                </div>
            </div>
        </>

    );
}

export default Stage2